import React from 'react';
import { Collapsible } from '../../components';

import { steps } from '../constants';
import { CoverSettings, AssignLookbook } from '../molecules';
import { useUpsertLookbook } from '../useUpsertLookbook';

export function Cover() {
  const {
    getCollapsibleState,
    toggleCollapsible,
    template,
    setTemplate,
    lookbookName,
    setLookbookName,
    lookbookDate,
    setLookbookDate,
    onAssignClient,
  } = useUpsertLookbook();
  const { isOpen, isVisible } = getCollapsibleState(steps.COVER);

  if (!isVisible) {
    return null;
  }

  return (
    <Collapsible
      trigger="Cover Page"
      handleTriggerClick={() => toggleCollapsible(steps.COVER)}
      open={isOpen}
      testId="lookbook-cover"
      noContainer
    >
      <div className="cover-page">
        <CoverSettings {...{
          template,
          setTemplate,
          lookbookName,
          setLookbookName,
          lookbookDate,
          setLookbookDate,
        }} />

        {isOpen && (
          <AssignLookbook onAssignClient={onAssignClient} />
        )}
      </div>
    </Collapsible>
  );
}
